<template>
  <div class="pageStyle" @touchstart="touchstart" @touchmove="touchmove">
    <!-- 头部 -->
    <div class="header">
      <!-- 第一行：产品图标 产品名称 -->
      <div class="item">
        <div class="left">
          <img :src="productMsg.productLog" alt="" />
        </div>
        <div class="productName">{{ productMsg.productName }}</div>
      </div>

      <!-- 第二行：产品特点 -->
      <div
        class="item"
        v-show="
          productMsg.advantage1 ||
          productMsg.advantage2 ||
          productMsg.advantage3
        "
      >
        <!-- 特点1 -->
        <div v-show="productMsg.advantage1">
          <img
            src="https://static.xchengtech.cn/32e120a14b8741fb8de8c92c5df552f9.png"
            alt=""
          />
          <span>{{ productMsg.advantage1 }}</span>
        </div>
        <!-- 特点2 -->
        <div v-show="productMsg.advantage2">
          <img
            src="https://static.xchengtech.cn/32e120a14b8741fb8de8c92c5df552f9.png"
            alt=""
          />
          <span>{{ productMsg.advantage2 }}</span>
        </div>
        <!-- 特点3 -->
        <div v-show="productMsg.advantage3">
          <img
            src="https://static.xchengtech.cn/32e120a14b8741fb8de8c92c5df552f9.png"
            alt=""
          />
          <span>{{ productMsg.advantage3 }}</span>
        </div>
      </div>

      <!-- 第三行：最高额度 利率 借款周期 -->
      <div class="item">
        <div v-show="productMsg.maxLine">
          <span>最高额度</span>
          <span
            class="blueColor"
            :style="
              depConfig.themeColor
                ? {
                    color: depConfig.themeColor,
                    borderColor: depConfig.themeColor,
                  }
                : ''
            "
            >{{ productMsg.maxLine }}万</span
          >
        </div>
        <div v-show="productMsg.minLine && productMsg.type == 'FYL'">
          <span>授信额度</span>
          <span class="blueColor">{{ productMsg.minLine }}万起</span>
        </div>
        <!-- 最高最低利率都存在时 -->
        <div v-show="productMsg.minRate && productMsg.maxRate">
          <span>年化利率</span>
          <span>{{ productMsg.minRate }}%-{{ productMsg.maxRate }}%</span>
        </div>
        <!-- 只有最高利率 -->
        <div v-show="!productMsg.minRate && productMsg.maxRate">
          <span>最高利率</span>
          <span>{{ productMsg.maxRate }}%</span>
        </div>
        <!-- 只有最低利率 -->
        <div v-show="productMsg.minRate && !productMsg.maxRate">
          <span>最低利率</span>
          <span>{{ productMsg.minRate }}%</span>
        </div>
        <div v-show="productMsg.period">
          <span>借款周期</span>
          <span>{{ productMsg.period }}月</span>
        </div>
      </div>

      <!-- 第四行：产品动态 -->
      <div class="item" v-if="productNotice[0]">
        <div class="itemBox" @click="noticePopup = !noticePopup">
          <div>
            <span
              >产品动态<s>
                {{ parseDay(productNotice[0].createDateTime) }}</s
              ></span
            >
            <span>{{ productNotice[0].content }}</span>
          </div>
          <div><van-icon name="arrow" /></div>
        </div>
      </div>
    </div>
    <!-- 打开侧边栏 -->
    <div class="sidebarShow">
      <div @click="sidebarShow = !sidebarShow">
        <span>{{ sidebarShow ? "收起侧边栏" : "打开侧边栏" }}</span>
        <img
          v-show="sidebarShow"
          src="https://static.xchengtech.cn/d499e2fd33954a4987efeaed3d21e827.png"
          alt=""
        />
        <img
          v-show="!sidebarShow"
          src="https://static.xchengtech.cn/5a955006270745e18951b989c976e1e0.png"
          alt=""
        />
      </div>
    </div>
    <!-- 内容区域 -->
    <div
      class="content"
      :style="
        sidebarShow
          ? { gridTemplateColumns: '24vw auto' }
          : { gridTemplateColumns: '0 auto' }
      "
    >
      <!-- 左侧导航 -->
      <div
        class="left"
        :style="sidebarShow ? { overflow: 'visible' } : { overflow: 'hidden' }"
      >
        <van-sidebar v-model="activeKey" @change="sidebarOnChange">
          <van-sidebar-item title="准入区域" v-show="areaDataForList[0]" />
          <van-sidebar-item
            title="产品简介"
            v-show="productDetailMsg.productDescriptionContent"
          />

          <van-sidebar-item
            title="企业要求"
            v-show="productDetailMsg.companyRequirementsContent"
          />
          <van-sidebar-item
            title="个人要求"
            v-show="productDetailMsg.individualRequirementsContent"
          />
          <van-sidebar-item
            title="征信要求"
            v-show="productDetailMsg.creditRequirementsContent"
          />
          <van-sidebar-item
            title="申请资料"
            v-show="productDetailMsg.applicationMaterialsContent"
          />
          <van-sidebar-item
            title="禁入行业"
            v-show="productDetailMsg.prohibitedIndustriesContent"
          />
          <van-sidebar-item
            title="申请流程"
            v-show="productDetailMsg.applicationProcessContent"
          />
          <van-sidebar-item
            title="佣金说明"
            v-show="productDetailMsg.commissionDetailsContent"
          />
          <van-sidebar-item
            title="电核内容"
            v-show="productDetailMsg.coreInstructionsContent"
          />
          <!-- <van-sidebar-item title="专属客服" /> -->
        </van-sidebar>
      </div>
      <!-- 右侧内容 -->
      <div class="right" ref="contentDiv">
        <!-- 准入地区 -->
        <div class="right-item zrdq" v-show="areaDataForList[0]">
          <div class="title">
            <div><span></span></div>
            <div>准入地区</div>
          </div>
          <div class="items">
            <div>您当前城市：</div>
            <div style="color: #4988fd" @click="toGgetDivision">
              {{ locateMsg.city }}
            </div>
            <div v-if="isAccess && locateMsg.adcode" class="isAccess">
              <van-icon name="checked" />准入
            </div>
            <div v-if="!isAccess && locateMsg.adcode" class="noAccess">
              <van-icon name="clear" />不准入
            </div>
          </div>
          <div class="items" @click="areaPopup = !areaPopup">
            <span>查看全部准入可申请地区</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <!-- 产品简介 -->
        <div
          class="right-item"
          v-show="productDetailMsg.productDescriptionContent"
        >
          <div class="title">
            <div><span></span></div>
            <div>产品简介</div>
          </div>
          <div
            class="right-item-content"
            v-html="productDetailMsg.productDescriptionContent"
          ></div>
        </div>

        <!-- 企业要求 -->
        <div
          class="right-item"
          v-show="productDetailMsg.companyRequirementsContent"
        >
          <div class="title">
            <div><span></span></div>
            <div>企业要求</div>
          </div>
          <div
            class="right-item-content"
            v-html="productDetailMsg.companyRequirementsContent"
          ></div>
        </div>
        <!-- 个人要求 -->
        <div
          class="right-item"
          v-show="productDetailMsg.individualRequirementsContent"
        >
          <div class="title">
            <div><span></span></div>
            <div>个人要求</div>
          </div>
          <div
            class="right-item-content"
            v-html="productDetailMsg.individualRequirementsContent"
          ></div>
        </div>
        <!-- 征信要求 -->
        <div
          class="right-item"
          v-show="productDetailMsg.creditRequirementsContent"
        >
          <div class="title">
            <div><span></span></div>
            <div>征信要求</div>
          </div>
          <div
            class="right-item-content"
            v-html="productDetailMsg.creditRequirementsContent"
          ></div>
        </div>
        <!-- 申请资料 -->
        <div
          class="right-item"
          v-show="productDetailMsg.applicationMaterialsContent"
        >
          <div class="title">
            <div><span></span></div>
            <div>申请资料</div>
          </div>
          <div
            class="right-item-content"
            v-html="productDetailMsg.applicationMaterialsContent"
          ></div>
        </div>
        <!-- 禁入行业 -->
        <div
          class="right-item"
          v-show="productDetailMsg.prohibitedIndustriesContent"
        >
          <div class="title">
            <div><span></span></div>
            <div>禁入行业</div>
          </div>
          <div
            class="right-item-content"
            v-html="productDetailMsg.prohibitedIndustriesContent"
          ></div>
        </div>
        <!-- 申请流程 -->
        <div
          class="right-item"
          v-show="productDetailMsg.applicationProcessContent"
        >
          <div class="title">
            <div><span></span></div>
            <div>申请流程</div>
          </div>
          <div
            class="right-item-content"
            v-html="productDetailMsg.applicationProcessContent"
          ></div>
        </div>
        <!-- 佣金说明 -->
        <div
          class="right-item"
          v-show="productDetailMsg.commissionDetailsContent"
        >
          <div class="title">
            <div><span></span></div>
            <div>佣金说明</div>
          </div>
          <div
            class="right-item-content"
            v-html="productDetailMsg.commissionDetailsContent"
          ></div>
        </div>
        <!-- 电核内容 -->
        <div
          class="right-item"
          v-show="productDetailMsg.coreInstructionsContent"
        >
          <div class="title">
            <div><span></span></div>
            <div>电核内容</div>
          </div>
          <div
            class="right-item-content"
            v-html="productDetailMsg.coreInstructionsContent"
          ></div>
        </div>
        <!-- 专属客服 -->
        <!-- <div class="right-item">
          <div class="title">
            <div><span></span></div>
            <div>专属客服</div>
          </div>
          <div class="right-item-content" v-html="productDetailMsg.productDescriptionContent"></div>
        </div> -->
      </div>
    </div>
    <!-- 立即申请 普通租户版本 -->
    <div class="foot" v-if="!depConfig.bizType">
      <div class="left">
        <div @click="toCustomerPopup(depConfig.customerServerEwm)">
          <img
            src="https://static.xchengtech.cn/7cc9ad4d263242acae5b7fdd7aaa41aa.png"
            alt=""
          />
          <span>在线客服</span>
        </div>
        <div @click="toSaveProductDetailForImg">
          <img
            src="https://static.xchengtech.cn/e1a68774c5504f5f8a60a6f28a01e715.png"
            alt=""
          />
          <span>保存图片</span>
        </div>
        <div @click="getApplyUrl">
          <img
            src="https://static.xchengtech.cn/43016c8f9eae43bd9eb42e9399695f53.png"
            alt=""
          />
          <span>分享产品</span>
        </div>
      </div>
      <div class="right">
        <!-- <span>分享赚钱</span> -->
        <span @click="toProductPoster"
          >立即进件<van-icon name="arrow" size="4.6vw"
        /></span>
      </div>
    </div>

    <!-- 立即申请 商户版本 只有进件按钮 -->
    <div class="sshFoot" v-else>
      <span @click="toProductPoster"
        >立即申请<van-icon name="arrow" size="4.6vw"
      /></span>
    </div>
    <!-- 返回首页按钮 -->
    <div class="return" ref="floating">
      <span @click="toPage('')"><van-icon name="revoke" />返回</span>
    </div>
    <!-- 准入地区弹窗 -->
    <van-popup
      v-model="areaPopup"
      position="bottom"
      round
      style="max-height: 70%"
    >
      <div class="areaPopup">
        <div class="title">可准入地区</div>
        <van-collapse v-model="areaActiveName" accordion>
          <van-collapse-item
            :title="item.name"
            :name="index"
            v-for="(item, index) in areaData"
            :key="index"
            ><div class="areaBox">
              <div class="areaTitle">可准入市：</div>
              <div class="areaTxt">
                <span v-for="(items, keys) in item.data" :key="keys">{{
                  items.name
                }}</span>
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </van-popup>
    <!-- 产品动态弹窗 -->
    <van-popup
      v-model="noticePopup"
      position="bottom"
      round
      style="max-height: 70%"
    >
      <div class="noticePopup">
        <div class="title">产品动态</div>
        <div class="noticePopup-content">
          <div class="item" v-for="(item, index) in productNotice" :key="index">
            <div><s></s>{{ parseTime(item.createDateTime) }}</div>
            <div>{{ item.content }}</div>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 在线客服弹窗 -->
    <van-popup
      v-model="customerPopup"
      position="bottom"
      round
      style="max-height: 70%"
    >
      <div class="customerPopup">
        <div class="title">在线客服</div>
        <div class="customerPopup-content">
          <img :src="depConfig.customerServerEwm" alt="" />
        </div>
      </div>
    </van-popup>
    <productDetailForImg ref="productDetailForImg"></productDetailForImg>
    <shareTips ref="shareTips"></shareTips>
  </div>
</template>

<script>
import {
  getXcProductDetail,
  getXcProductNews,
  getXcProduct,
  getXcAreaConfig,
} from "@/api/product.js";
import { getDivision } from "@/utils/wxJsSdk.js";
import { areaList } from "@vant/area-data";
import { getToken } from "@/utils/auth.js";
import { getDepNameByDomain } from "@/utils/index";
import { xcDepConfig } from "@/api/depConfig.js";
import { parseTime, parseDay } from "@/utils/index.js";
import productDetailForImg from "./modoule/productDetailForImg.vue";
import shareTips from "./modoule/shareTips.vue";
import Vue from "vue";
import { getWx } from "@/utils/wxJsSdk.js";
import { getPoster } from "@/api/product.js";
import {
  Icon,
  Sidebar,
  SidebarItem,
  Popup,
  Collapse,
  CollapseItem,
  Toast,
} from "vant";
Vue.use(Icon);
Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Popup);
Vue.use(Collapse);
Vue.use(CollapseItem);
export default {
  components: { productDetailForImg, shareTips },
  data() {
    return {
      sidebarShow: true,
      activeKey: 0,
      areaPopup: false,
      noticePopup: false,
      customerPopup: false,
      areaActiveName: "0",
      areaData: [],
      // 列形式的地区数据 用于判断当前地区是否可做
      areaDataForList: [],
      productId: "",
      productMsg: {},
      productDetailMsg: {},
      productNotice: [],
      areaList,
      isAccess: false,
      locateMsg: {
        adcode: "",
        city: "点击获取定位",
        country: "",
        formattedAddress: "",
        province: "",
      },
      depName: "",
      depConfig: {},
      applyUrl: "",
      // 页面滑动时的数据
      startY: "",
      moveY: "",
    };
  },
  created() {},
  watch: {
    // 判断当前地区是否准入
    locateMsg: {
      immediate: true,
      handler(newValue, oldValue) {
        console.log("newValue", newValue);
        // 如果有地区数据 并且准入地区也有数据 进行判断是否准入
        if (newValue.adcode && this.areaDataForList[0]) {
          let s = this.areaDataForList.find((item) => {
            return newValue.city == item;
          });
          console.log("s", s);
          if (s) {
            this.isAccess = true;
          } else {
            this.isAccess = false;
          }
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.productId = this.$route.query.productId;
    this.getProductMsg();
    // this.getChannelMsg();
    this.getProductDetail();
    this.getXcProductNews();
    // 获取产品可入地区后，再获取微信定位 否侧异步事件，无法判断是否准入
    this.getAreaData();
    this.getDepConfig();
  },

  methods: {
    toCustomerPopup(ewm) {
      if (ewm) {
        this.customerPopup = !this.customerPopup;
      } else {
        Toast.fail("暂无客服");
      }
    },

    parseTime,
    parseDay,
    getDepConfig() {
      this.depName = getDepNameByDomain();
      xcDepConfig(this.depName).then((res) => {
        this.depConfig = res;
      });
    },
    getProductMsg() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      getXcProduct(this.productId)
        .then((res) => {
          this.productMsg = res;
          this.$refs.productDetailForImg.productMsg = res;
          // 获取分享内容模板
          this.getShareTxt();
          Toast.clear();
        })
        .catch((err) => {
          console.log("err", err);
          Toast.clear();
        });
    },
    toGgetDivision() {
      getDivision().then((res) => {
        this.locateMsg = res;
        console.log("getwx :>> ", res);
      });
    },
    // 屏幕滑动事件
    touchstart(e) {
      this.startY = e.touches[0].clientY;
    },
    touchmove(e) {
      this.moveY = e.touches[0].clientY;
      //  this.startY - this.moveY <= 0 ? console.log('你在往上滑') : console.log('你在往下滑')
      if (this.startY - this.moveY <= 0) {
        // 从上往下拉 显示
        this.$refs["floating"].style.right = "2vw";
      } else {
        // 从下往上拉 隐藏
        this.$refs["floating"].style.right = "-10vw";
      }
    },
    getAreaData() {
      getXcAreaConfig(this.productId).then((res) => {
        let areaData = {};
        res.forEach((item) => {
          let s = [item.cityCode.substring(0, 2) + "0000"];
          if (!areaData[s]) {
            areaData[s] = {
              name: areaList.province_list[s],
              data: [],
            };
            areaData[s].data.push({
              code: item.cityCode,
              name: areaList.city_list[item.cityCode],
            });
          } else {
            areaData[s].data.push({
              code: item.cityCode,
              name: areaList.city_list[item.cityCode],
            });
          }
          // 所有城市的合集
          this.areaDataForList.push(areaList.city_list[item.cityCode]);
        });
        this.areaData = areaData;
        // 如果没有可进件地区 不需要获取当前定位
        if (this.areaDataForList[0]) {
          // 获取微信定位
          this.toGgetDivision();
        }
      });
    },
    sidebarOnChange(e) {
      let div = document.getElementsByClassName("right-item")[e];
      div.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    toProductPoster() {
      // 判断业务类型是否是商协会模式
      if (
        this.depConfig.bizType === "ssh" ||
        this.depConfig.bizType === "csqfpt"
      ) {
        // 退伍军人协会定制 xrr
        if (this.depConfig.depName == "xrr") {
          // 直接跳转免登录 融资申请
          this.$router.push({
            path: "/leadInfoForXrr",
            query: {
              productId: this.productMsg.id,
            },
          });
        } else {
          // 直接跳转免登录 融资申请
          this.$router.push({
            path: "/leadInfoNL",
            query: {
              productId: this.productMsg.id,
            },
          });
        }
      }
      // 广州好邻科技有限公司模式 直接跳转至统一进件页面 业务分配至指定渠道
      else if (this.depConfig.bizType === "gzhlkj") {
        window.location.href =
          "https://apply.xchengtech.cn/#/apply?productId=" +
          this.productMsg.id +
          "&channelId=9547f9d7aad54ca09cedae9653eaf20d";
      } else {
        // 租户模式
        // 判断是否登录
        if (getToken()) {
          // 已登录：判断进件模式
          // 进件模式为：留资
          if (this.depConfig.applyModel === "LEAD") {
            this.$router.push({
              path: "/leadInfo",
              query: {
                productId: this.productMsg.id,
              },
            });
          }
          // 其他进件模式：获取进件链接
          else {
            Toast.loading({
              duration: 0, // 持续展示 toast
              forbidClick: true,
              message: "加载中",
            });
            getPoster(this.productMsg.id, 0)
              .then((res) => {
                console.log("res", res);
                window.location.href = res.applyUrl;
                Toast.clear();
              })
              .catch((err) => {
                console.log("err", err);
                Toast.clear();
              });

            // this.$router.push({
            //   path: "/productPoster",
            //   query: {
            //     productId: this.productMsg.id,
            //   },
            // });
          }
        }
        // 未登录：前去登录
        else {
          this.$router.push({
            path: "/login",
          });
        }
      }
    },
    toPage(name) {
      switch (name) {
        default:
          this.$router.push({ path: "/" + name });
          break;
      }
    },
    getProductDetail() {
      if (this.productId) {
        getXcProductDetail(this.productId).then((res) => {
          for (let key in res) {
            if (res[key] === "<p><br></p>") {
              res[key] = "";
            }
          }
          this.productDetailMsg = res;
          this.$refs.productDetailForImg.productDetailMsg = res;
        });
      }
    },
    getXcProductNews() {
      if (this.productId) {
        getXcProductNews(this.productId).then((res) => {
          this.productNotice = res.sort((a, b) => {
            return b.createDateTime - a.createDateTime;
          });
        });
      }
    },
    // 保存产品详情图
    toSaveProductDetailForImg() {
      this.$refs.productDetailForImg.show = true;
      this.$nextTick(() => {
        // 获取二维码
        this.$refs.productDetailForImg.getQrCode();
        this.$refs.productDetailForImg.divToImg();
      });
    },
    // 获取产品分享链接
    getApplyUrl() {
      // 判断是否已登录
      if (getToken()) {
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        // 获取进件链接 默认10天
        getPoster(this.productId, "14400")
          .then((res) => {
            this.applyUrl = res.applyUrl;
            this.$refs.shareTips.show = true;
            // 获取分享内容模板
            this.getShareTxtForApplyUrl();
            Toast.clear();
          })
          .catch((err) => {
            Toast.clear();
            console.log("err", err);
          });
      } else {
        this.$router.push({
          path: "/login",
        });
      }
    },
    getShareTxt() {
      let desc = "点击查看";
      let that = this;
      let icon = this.depConfig.channelLogoSrc
        ? this.depConfig.channelLogoSrc
        : "https://static.xchengtech.cn/4a6254f9d27042ddabb8c7d8c766b9bc.png";
      getWx().then((res) => {
        window.wx.updateAppMessageShareData({
          title: that.productMsg.productName, // 分享标题
          desc: desc, // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: icon, // 分享图标
          success: function (res) {
            console.log("res", res);
            //afterShare();
          },
        });
      });
    },
    getShareTxtForApplyUrl() {
      let desc = "点击进件，链接有效期：10天";
      let that = this;
      let icon = this.depConfig.channelLogoSrc
        ? this.depConfig.channelLogoSrc
        : "https://static.xchengtech.cn/4a6254f9d27042ddabb8c7d8c766b9bc.png";
      getWx().then((res) => {
        window.wx.updateAppMessageShareData({
          title: that.productMsg.productName, // 分享标题
          desc: desc, // 分享描述
          link: that.applyUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: icon, // 分享图标
          success: function (res) {
            console.log("res", res);
            //afterShare();
          },
        });
      });
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/productDetail/index.vue